import {
  FETCH_INVOICES_SUCCESS,
  FETCHING_INVOICES,
  FETCHING_INVOICES_LINES,
  FETCHING_INVOICES_LINES_SUCCESS, RESET_INVOICES, RESET_INVOICES_LINES,
  FETCHING_INVOICES_LINES_UNFILTERED,
  FETCH_INVOICE_SUCCESS, FETCHING_INVOICE
} from './InvoicesConstants';

const initialState = {
  invoice: {
    grossAmount: '',
    date: '',
    lineStatus: '',
    vendorName: '',
    invoice: '',
    vendorTax: '',
    calculatedTax: '',
    dollarVariance: '',
    percentVariance: ''
  },
  invoices: [],
  invoicesLines: [],
  pageState: {
    page: 0,
    perPage: 10,
    totalEntries: 0,
    totalPages: 0
  },
  pageStateLines: {
    page: 0,
    perPage: 10,
    totalEntries: 0,
    totalPages: 0
  },
  fetchingInvoices: false,
  fetchingInvoicesLines: false,
  fetchingInvoice: false,
  closeSlidingPanelFlag: false
};

const InvoicesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCHING_INVOICES:
      return {
        ...state,
        fetchingInvoices: true
      };
    case RESET_INVOICES:
      return {
        ...state,
        invoices: []
      };
    case FETCH_INVOICES_SUCCESS:
      return {
        ...state,
        fetchingInvoices: false,
        invoices: action.invoices,
        pageState: action.pageState
      };
    case FETCHING_INVOICES_LINES_SUCCESS:
      return {
        ...state,
        fetchingInvoicesLines: false,
        invoicesLines: action.invoicesLines,
        pageStateLines: action.pageState,
        closeSlidingPanelFlag: false
      };
    case FETCHING_INVOICES_LINES_UNFILTERED:
      return {        
        ...state,
        closeSlidingPanelFlag: action.invoicesLines.items.length === 0
      };
    case FETCHING_INVOICES_LINES:
      return {
        ...state,
        fetchingInvoicesLines: true
      };
    case RESET_INVOICES_LINES:
      return {
        ...state,
        invoicesLines: []
      };
    case FETCH_INVOICE_SUCCESS:
      return {
        ...state,
        invoice: action.invoice,
        fetchingInvoice: false
      };
    case FETCHING_INVOICE:
      return {
        ...state,
        fetchingInvoice: true
      };
    default:
      return state;
  }
};

export default InvoicesReducer;



// WEBPACK FOOTER //
// ./src/redux/invoices/InvoicesReducer.js